import React from "react";
import PropTypes from "prop-types";

/**
 * Single preference checkbox row (label + input).
 */
const PreferenceCheckboxRow = ({ label, name, checked, onChange }) => (
  <div className="mb-2 col-11 d-flex justify-content-evenly">
    <label className="col-5 fs-13 d-flex justify-content-start">{label}</label>
    <input
      type="checkbox"
      name={name}
      checked={checked}
      onChange={onChange}
    />
  </div>
);

PreferenceCheckboxRow.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default PreferenceCheckboxRow;
